
<template>
  <v-tooltip top>
    <template v-slot:activator="{ on: tooltip }">
      <v-btn
        class="mt-1 mr-2 pt-2 mt-5 text-none"
        elevation="2"
        x-large
        color="green lighten-3"
        @click="discardChanges"
        v-on="{ ...tooltip }"
      >
        Откатить изменения
      </v-btn>
    </template>
    <span>Вернуться к настройкам шаблона</span>
  </v-tooltip>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    dialog: false,
    url: "/templates/update_template/",
    popup: false,
    popupText: "",
    timeout: 2,
    loading: false,
  }),

  methods: {
    ...mapGetters(["getSettings", "getCurrentTemplateUID", "getUserTemplates"]),
    ...mapActions(["setTemplateChanged", "setSettings"]),

    discardChanges: function () {
      // console.log("Discarding changes...");
      //   var settings = this.getSettings();
      var uid = this.getCurrentTemplateUID();
      var templates = this.getUserTemplates();
      // console.log("UID: " + uid);
      // console.log("templates: " + templates);
      for (var template in templates) {
        var tmp_uid = templates[template].uid;
        if (tmp_uid == uid) {
          var default_settings = JSON.parse(
            JSON.stringify(templates[template].settings)
          );
          // console.log("Discard settings: " + JSON.stringify(default_settings));
          this.setSettings({ value: default_settings });
          this.$emit("filter_update");
          return;
        }
      }
      //   this.loading = true;
      //   api
      //     .post(this.url, { settings, name })
      //     .then((response) => {
      //       console.log("response:" + JSON.stringify(response.data));
      //       this.popupText = "Изменения сброшены";
      //       this.popup = true;
      //     })
      //     .catch((error) => {
      //       console.log(error.data);
      //     });
      //   this.loading = false;
      //   this.setTemplateChanged({ value: false });
    },
  },
};
</script>

<style scoped></style>

